import { PricingTier } from '../types';

export const pricingTiers: PricingTier[] = [
  {
    id: 1,
    name: "AI Readiness & Opportunity Scan",
    description: "A comprehensive assessment of your organization's AI readiness and opportunities.",
    timeline: "2-3 weeks",
    hours: "40-50",
    idealFor: "Companies just starting to explore GenAI or looking to align stakeholders around clear next steps",
    features: [
      "Stakeholder interviews",
      "Comprehensive AI landscape scan",
      "Internal maturity assessment (tools, knowledge, skills)",
      "Identification of low-hanging fruit and quick wins",
      "Executive summary slide deck"
    ]
  },
  {
    id: 2,
    name: "AI Strategy & Roadmap",
    description: "Everything in Tier 1, plus comprehensive strategy development and governance framework.",
    timeline: "4-6 weeks",
    hours: "90-110",
    idealFor: "Companies ready to operationalize AI with a clear plan and governance framework.",
    features: [
      "Everything in Tier 1",
      "ROI assessment of custom AI use cases",
      "Definition of AI north star & success metrics",
      "3-horizon roadmap (Years 1-3)",
      "Ethical AI & risk governance checklist",
      "Full strategic plan (PDF/Doc & deck format)"
    ]
  },
  {
    id: 3,
    name: "Full AI Enablement",
    description: "Everything in Tier 2, plus strategic planning and ongoing team enablement support.",
    timeline: "6-8 weeks",
    hours: "130-150",
    idealFor: "Companies looking for strategic planning plus team enablement and ongoing support.",
    features: [
      "Everything in Tier 2",
      "2 x customized team workshops (e.g., 'GenAI for Product Teams', 'How to Identify AI Use Cases')",
      "Live working session to prioritize roadmap",
      "Custom stakeholder presentation prep (for board, investors, or company-wide rollout)",
      "Access to Q&A support for 30 days post-delivery"
    ]
  }
];